import React, { useEffect, useState } from 'react';
import useSWR from 'swr';
import { useHistory } from 'react-router-dom';
import { Button } from '../components/styled/button';
import { PageHeader } from '../components/PageHeader';
import { listReferralsUrl } from '../lib/apiUrls';
import stubAgencyName from '../lib/stubAgencyName';
import { TabList } from '../components/styled/tabList';
import { Tab } from '../components/styled/tab';
import {
  Table,
  TableCell,
  TableColHead,
  TableHeader,
  TableBody,
  TableRow,
} from '../components/styled/tables';

import type { ReferralData } from '../types/referral';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const getHumanDateFromISOString = (dateString: string) => {
  if (!dateString || dateString === 'undefined') return '';
  const date = new Date(dateString);
  return `${
    monthNames[date.getMonth()]
  } ${date.getDate()}, ${date.getFullYear()}`;
};

const Referrals: React.FC = () => {
  const { data: referralListData } = useSWR<ReferralData>(
    listReferralsUrl(stubAgencyName)
  );
  const [tableData, setTableData] = useState<string[][]>([[]]);
  const [sortByIndex, setSortByIndex] = useState<number>(-1);
  const [sortOrder, setSortOrder] = useState<number>(1);
  const history = useHistory();

  useEffect(() => {
    const data =
      referralListData &&
      referralListData.map(referral => {
        return [
          `${referral.childFirstName} ${referral.childLastName}`,
          `${getHumanDateFromISOString(referral.childDateOfBirth)}`,
          '',
          `${getHumanDateFromISOString(referral.dateOfInitialReferral)}`,
        ];
      });
    if (data) {
      if (sortByIndex > -1) {
        data.sort((a, b) => {
          if (a[sortByIndex] < b[sortByIndex]) return -1 * sortOrder;
          if (a[sortByIndex] > b[sortByIndex]) return sortOrder;
          return 0;
        });
      }
      setTableData(data);
    }
  }, [referralListData, sortByIndex, sortOrder]);
  const sortByColumnIdx = (i: number) => {
    if (i === sortByIndex) {
      setSortOrder(sortOrder * -1);
    } else {
      setSortByIndex(i);
    }
  };

  const draftsLabel = `Drafts (${tableData ? tableData.length : 0})`;

  return (
    <>
      <PageHeader title={'Referrals'}>
        <Button onClick={() => history.push('/create-referral')}>
          Create Referral
        </Button>
      </PageHeader>
      <TabList>
        <Tab selected={true} title={draftsLabel} />
      </TabList>
      {tableData && (
        <Table>
          <TableHeader>
            <TableRow>
              {['Name', 'DOB', 'Created By', 'Date Added'].map((heading, i) => (
                <TableColHead
                  key={`data-table-header-${i}`}
                  onClick={() => sortByColumnIdx(i)}
                >
                  {heading}
                </TableColHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {tableData &&
              tableData.map((record: string[], idx: number) => (
                <TableRow key={`data-table-row-${idx}`}>
                  {record.map((field: string, j: number) => (
                    <TableCell key={`data-table-cell-${idx}-${j}`}>
                      {field || '–'}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export { Referrals };
